import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DateRangePicker = ({ startDate, endDate, setStartDate, setEndDate }) => {
    return (
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem' }}>
            <div>
                <label style={{ marginRight: '0.5rem' }}>Start Date:</label>
                <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd-MM-yyyy"
                    maxDate={new Date()}
                />
            </div>
            <div>
                <label style={{ marginRight: '0.5rem' }}>End Date:</label>
                <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    dateFormat="dd-MM-yyyy"
                    maxDate={new Date()}
                />
            </div>
        </div>
    );
};

export default DateRangePicker;
